import { render, staticRenderFns } from "./Fundamentals.vue?vue&type=template&id=f5089e64&"
import script from "./Fundamentals.vue?vue&type=script&lang=js&"
export * from "./Fundamentals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports